import { CustomerTypes } from '~/screens/select-utility';
import { UnparsedQueryParams } from '../../types';

const validateCustomerType = (customerType: string) => {
  return customerType === 'Business' || customerType === 'Residential';
};

export const handleCustomerType = (params: UnparsedQueryParams): CustomerTypes | undefined => {
  const { customerType } = params;
  if (!customerType) return undefined;
  if (validateCustomerType(customerType)) {
    return customerType as CustomerTypes;
  }
  return undefined;
};
